<template>
    <div v-if="status === 'loading'">
        <a-icon icon="Spinner" />
    </div>
    <div v-else-if="item && status === 'idle'" class="o-deficiencies__item">
        <div class="o-deficiencies__imageWrapper">
            <m-gallery v-if="item.images" :images="item.images" />
        </div>
        <div class="o-deficiencies__descriptionWrapper">
            <b>Opis</b>
            <div v-if="item.description" v-html="item.description"></div>
            <p v-else>Brak opisu</p>
        </div>
        <div class="o-deficiencies__mineralListWrapper">
            <b>Objawy niedoborów / pierwiastki</b>
            <div
                v-if="groupItem && groupItem.deficiencies"
                class="o-deficiencies__mineralList"
            >
                <button
                    @click="
                        $router.push({
                            name: 'deficienciesItem',
                            params: { id: deficienciesItem.id },
                        })
                    "
                    v-for="deficienciesItem in groupItem.deficiencies"
                    :key="deficienciesItem.id"
                    class="a-button"
                    :class="{
                        'a-button--disabled': deficienciesItem.id === item.id,
                    }"
                >
                    {{ deficienciesItem.element_name }}
                </button>
            </div>
            <p v-else>Brak informacji</p>
        </div>
        <div class="o-deficiencies__protectorsWrapper">
            <b>Powiązane środki</b>
            <div class="o-deficiencies__protectorList">
                <template
                    v-if="item.agriiProtectors.length || item.protectors.length"
                >
                    <div
                        v-for="protector in item.agriiProtectors"
                        class="m-list__item"
                        :key="protector.id"
                        @click="
                            $router.push({
                                name: 'protector',
                                params: { id: protector.id },
                            })
                        "
                    >
                        <div class="m-list__itemPhoto">
                            <a-image
                                v-if="
                                    protector.view_photos &&
                                    protector.view_photos.length > 0 &&
                                    !!protector.view_photos.find(
                                        (image) => image.is_main === true
                                    )
                                "
                                :src="
                                    protector.view_photos.find(
                                        (image) => image.is_main === true
                                    ).full_uri
                                "
                                :alt="protector.name"
                            />
                            <a-icon v-else icon="Protectors" />
                        </div>
                        <p
                            class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize o-protectors__item"
                            :class="{
                                'o-protectors__item--selected':
                                    item.agrii_protectors &&
                                    item.agrii_protectors.length > 0,
                            }"
                            :style="
                                authIsAdvisor && item.position_group
                                    ? {
                                          color: item.position_group.hex,
                                      }
                                    : false
                            "
                        >
                            {{ protector.name }}
                            <span
                                v-if="protector.is_deleted"
                                class="m-list__itemTitleRed"
                            >
                                <br />archiwalny
                            </span>
                        </p>
                        <div class="m-list__itemIcons">
                            <a-icon
                                v-if="protector.youtube_link"
                                class="m-list__icon"
                                icon="Video"
                            />
                            <a-icon
                                v-if="protector.notes"
                                class="m-list__icon"
                                :icon="
                                    protector.notes &&
                                    protector.notes.length > 0
                                        ? 'Note'
                                        : 'NoteLight'
                                "
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="
                                    protector.is_favorite
                                        ? 'Favorite'
                                        : 'FavoriteLight'
                                "
                            />
                        </div>
                    </div>
                </template>
                <p v-else>Brak środków do wyświetlenia</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        status() {
            return this.$store.getters['deficiencies/status']
        },
        item() {
            return this.$store.getters['deficiencies/activeItem']
        },
        groupItem() {
            return this.$store.getters['deficiencies/groupItem']
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    methods: {
        async fetchItem(id) {
            await this.$store.dispatch('deficiencies/fetchItem', id)
        }
    },
    watch: {
        async item(newItem) {
            if (newItem) {
                await this.$store.dispatch(
                    'deficiencies/fetchCropGroupItem',
                    newItem.crop_group_id
                )
            }
        }
    },
    async created() {
        this.fetchItem(this.$route.params.id)
    },
    destroyed() {
        this.$store.dispatch('deficiencies/resetItem')
    }
}
</script>